import moment from "moment";
import React, { useState } from "react";
import { RegionsNameNum } from "service/constant/burialConstant";
import { TwoBtnModal } from "components/common/modal";
import { delRecommend } from "service/api/recommend";
import type { IRecommendList } from "service/interface/burial";
import { KeyedMutator } from "swr";
import responseCodeConstant from "service/constant/responseCodeConstant";

interface Props {
  data: IRecommendList[];
  mutate: KeyedMutator<any>;
}

export function RecommendListTable({ data, mutate }: Props) {
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [selectDelId, setSelectDelId] = useState<number>(0);

  const handleDelBtn = (id: number) => {
    setSelectDelId(id);
    setIsDeleteModalVisible(true);
  };

  const handleDelModalClick = async () => {
    const delRes = await delRecommend(selectDelId + "");
    if (delRes.status === responseCodeConstant.SUCCESS.ok) {
      mutate();
    }
  };

  return (
    <>
      <TwoBtnModal
        isVisible={isDeleteModalVisible}
        setIsVisible={setIsDeleteModalVisible}
        title="삭제 확인"
        subTitle="해당 추천 리스트를 삭제하시겠습니까?"
        btnClick={handleDelModalClick}
        btnLabel="삭제하기"
      />
      <div className="w-ful">
        <table className="w-full divide-y divide-[#d1dff3]">
          <thead>
            <tr>
              <th
                scope="col"
                className="min-w-[55px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
              >
                ID
              </th>
              <th
                scope="col"
                className="min-w-[102px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
              >
                운영 형태
              </th>
              <th
                scope="col"
                className="min-w-[112px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
              >
                시도
              </th>
              <th
                scope="col"
                className="min-w-[152px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
              >
                시설명
              </th>
              <th
                scope="col"
                className="min-w-[298px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
              >
                주소
              </th>
              <th
                scope="col"
                className="min-w-[152px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
              >
                생성일
              </th>
              <th
                scope="col"
                className="min-w-[152px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
              >
                편집
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {data.map((recommend) => (
              <tr
                key={recommend.id}
                className="even:bg-[#fbfbfb] hover:bg-blue-2"
              >
                <td className="whitespace-nowrap px-[15px] py-[16px] text-M1 text-gray-5">
                  {recommend.id}
                </td>
                <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                  {recommend.isPublic ? "공설" : "사설"}
                </td>
                <td className="text-ellipsis whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                  {RegionsNameNum[recommend.region]}
                </td>
                <td className="max-w-[152px] overflow-hidden text-ellipsis whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                  {recommend.name}
                </td>
                <td className="max-w-[298px] overflow-hidden text-ellipsis whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                  {recommend.address}
                </td>
                <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                  {moment(recommend.createdAt).format("YYYY-MM-DD")}
                </td>
                <td
                  onClick={() => handleDelBtn(recommend.id)}
                  className="cursor-pointer text-ellipsis whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5 underline"
                >
                  삭제
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
